/**
 * Created by i.lovenkov on 29.11.16.
 */

"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _redboxReact2 = require('redbox-react');

var _redboxReact3 = _interopRequireDefault(_redboxReact2);

var _react2 = require('react');

var _react3 = _interopRequireDefault(_react2);

var _reactTransformCatchErrors3 = require('react-transform-catch-errors');

var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);

var _class, _temp;

var _reactRouter = require('react-router');

var _components2 = require('components');

require('./MyMenu.less');

var _constants = require('redux/constants');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _components = {
    MyMenuView: {
        displayName: 'MyMenuView'
    }
};

var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
    filename: '/usr/local/ibonus/src/components/Hamburger/MyMenu/default/MyMenuView.jsx',
    components: _components,
    locals: [],
    imports: [_react3.default, _redboxReact3.default]
});

function _wrapComponent(id) {
    return function (Component) {
        return _reactTransformCatchErrors2(Component, id);
    };
}

var MyMenuView = _wrapComponent('MyMenuView')((_temp = _class = function (_Component) {
    (0, _inherits3.default)(MyMenuView, _Component);

    function MyMenuView(props) {
        (0, _classCallCheck3.default)(this, MyMenuView);
        return (0, _possibleConstructorReturn3.default)(this, (MyMenuView.__proto__ || (0, _getPrototypeOf2.default)(MyMenuView)).call(this, props));
    }

    (0, _createClass3.default)(MyMenuView, [{
        key: 'render',
        value: function render() {
            var _this2 = this;

            var lang = this.props.lang;


            return _react3.default.createElement(
                'div',
                { className: 'mobile_catalog', key: this.props.title },
                _react3.default.createElement('span', { className: 'fa fa-arrow-left back_button', onClick: this.props.handleBackClick }),
                _react3.default.createElement(
                    'span',
                    { className: 'catalog_title' },
                    lang['store.my_menu.title']
                ),
                _react3.default.createElement(
                    'ul',
                    null,
                    _constants.UserMenuItems.map(function (item, i) {
                        var item_name = lang[item.lang_mark] ? lang[item.lang_mark] : item.name;

                        if (item.link) {
                            return _react3.default.createElement(
                                'li',
                                { key: 'li-' + i, className: 'row no-margin' },
                                _react3.default.createElement(
                                    _reactRouter.Link,
                                    {
                                        to: item.link,
                                        onClick: _this2.props.handleClick
                                    },
                                    item_name
                                ),
                                item.showNotification ? _react3.default.createElement(_components2.Notification, { className: 'holder_login_icon' }) : null
                            );
                        } else {
                            return _react3.default.createElement(
                                'li',
                                { key: 'li-' + i, className: 'row no-margin' },
                                _react3.default.createElement(
                                    'a',
                                    { onClick: _this2.props[item.method] },
                                    item_name
                                ),
                                item.showNotification ? _react3.default.createElement(_components2.Notification, { className: 'holder_login_icon' }) : null
                            );
                        }
                    })
                )
            );
        }
    }]);
    return MyMenuView;
}(_react2.Component), _class.propTypes = {
    lang: _react2.PropTypes.object
}, _temp));

exports.default = MyMenuView;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Hamburger/MyMenu/default/MyMenuView.jsx
// module id = 1671
// module chunks = 0